import { render, staticRenderFns } from "./bidNoticeSuccessful.vue?vue&type=template&id=0713969c&scoped=true"
import script from "./bidNoticeSuccessful.vue?vue&type=script&lang=js"
export * from "./bidNoticeSuccessful.vue?vue&type=script&lang=js"
import style0 from "./bidNoticeSuccessful.vue?vue&type=style&index=0&id=0713969c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0713969c",
  null
  
)

export default component.exports